export default "__VITE_ASSET__BfDpV4ZZ__"